import { useSearchStore } from '@stores/search.store'

import { ComponentType, useMemo } from 'react'

import dynamic from 'next/dynamic'

import { JobSearch } from '@types'

import { useShallow } from 'zustand/react/shallow'

import Checkbox from '@components/inputs/checkbox'
import DistanceFilter from '@components/inputs/distance-filter'
import { ItemType } from '@components/inputs/dropdown'
import { DropDownProps } from '@components/inputs/dropdown/dropdown'
import useDateTime from '@hooks/client/useDateTime'

const DropDown = dynamic(() => import('@components/inputs/dropdown')) as ComponentType<DropDownProps<string>>

export default function JobTypeFilters({ search }: { search: JobSearch }): JSX.Element {
  const dateTime = useDateTime()
  const [nextSearch, addParamsToSearch] = useSearchStore(
    useShallow((state) => [state.nextSearch, state.addParamsToSearch]),
  )
  const { fullTime, partTime, noExperience, remote } = nextSearch

  const datePostedOptions: ItemType<string>[] = useMemo(
    () => [
      { value: '', label: 'Anytime' },
      {
        value: dateTime().subtract(1, 'days').toISOString(),
        label: 'Last 24 hours',
      },
      {
        value: dateTime().subtract(3, 'days').toISOString(),
        label: 'Last 3 days',
      },
      {
        value: dateTime().subtract(7, 'days').toISOString(),
        label: 'Last 7 days',
      },
      {
        value: dateTime().subtract(14, 'days').toISOString(),
        label: 'Last 14 days',
      },
    ],
    [dateTime],
  )

  return (
    <>
      {(search.location.id || search.location.name) && (
        <>
          <div id="search-radius" style={{ margin: '10px 0', fontSize: 16, fontWeight: 'bold' }}>
            Distance from {search.location.name}
          </div>
          <DistanceFilter
            value={nextSearch.maxRadius}
            onChange={(o): void => addParamsToSearch({ maxRadius: o.value })}
          />
        </>
      )}
      <div id="date-posted" style={{ margin: '10px 0', fontSize: 16, fontWeight: 'bold' }}>
        Date Posted
      </div>
      <DropDown
        ariaLabelledBy="date-posted"
        menuPlacement="bottom"
        options={datePostedOptions}
        initialValue={datePostedOptions[0]}
        onChange={(o): void => addParamsToSearch({ createdAfter: o.value })}
        id="datePosted"
      />
      <br />
      <Checkbox
        label="Full-time"
        id="fulltime"
        checked={fullTime}
        onChange={(e): void => addParamsToSearch({ fullTime: e.target.checked })}
      />
      <Checkbox
        label="Part-time"
        id="parttime"
        checked={partTime}
        onChange={(e): void => addParamsToSearch({ partTime: e.target.checked })}
      />
      <Checkbox
        label="No Experience required"
        id="noexperience"
        checked={noExperience}
        onChange={(e): void => addParamsToSearch({ noExperience: e.target.checked })}
      />
      <Checkbox
        label="Remote"
        id="remote"
        checked={remote}
        onChange={(e): void => addParamsToSearch({ remote: e.target.checked })}
      />
    </>
  )
}
